import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useGendersApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/genders', 'get');
    return { data, loading, error, refetch };
};
